export default "__VITE_ASSET__BCsCOc0a__"